import { store } from "store";
export var routes = [
    {
        name: "Start",
        path: "/",
        component: require("views/StartView").default,
        beforeEnter: function (to, from, next) {
            if (store.ui && !store.ui.exitConfirmed && store.state.dirty) {
                store.ui.navigateToStartPopupOpen = true;
                next(false);
            }
            else {
                next();
            }
        }
    },
    { name: "Worktop", path: "/worktop", component: require("views/WorktopView").default },
    { name: "Backpanel", path: "/backpanel", component: require("views/BackpanelView").default },
    {
        name: "Material",
        path: "/material",
        component: require("views/MaterialView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui || !store.ui.worktopSelectionsComplete)
                next(false);
            else
                next();
        }
    },
    {
        name: "BackpanelMaterial",
        path: "/backpanel-material",
        component: require("views/BackpanelMaterialView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui || !store.ui.backpanelSelectionsComplete)
                next(false);
            else
                next();
        }
    },
    {
        name: "Sink",
        path: "/sink",
        component: require("views/SinkView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui || !store.ui.materialSelectionsComplete || !store.ui.worktopSelectionsComplete)
                next(false);
            else
                next();
        }
    },
    {
        name: "HobCutout",
        path: "/hobcutout",
        component: require("views/HobCutoutView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui || !store.ui.sinkSelectionsComplete || !store.ui.materialSelectionsComplete || !store.ui.worktopSelectionsComplete)
                next(false);
            else
                next();
        }
    },
    {
        name: "Accessories",
        path: "/accessories",
        component: require("views/AccessoriesView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui || !store.ui.hobcutoutSelectionsComplete || !store.ui.sinkSelectionsComplete || !store.ui.materialSelectionsComplete || !store.ui.worktopSelectionsComplete)
                next(false);
            else
                next();
        }
    },
    {
        name: "Summary",
        path: "/summary",
        component: require("views/SummaryView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui ||
                (store.state.mode == "backpanel" && (!store.ui.backpanelSelectionsComplete || !store.ui.backpanelMaterialSelectionsComplete)) ||
                (store.state.mode == "worktop" && (!store.ui.hobcutoutSelectionsComplete || !store.ui.sinkSelectionsComplete || !store.ui.materialSelectionsComplete || !store.ui.worktopSelectionsComplete))) {
                next(false);
            }
            else
                next();
        }
    },
    {
        name: "Thankyou",
        path: "/thankyou",
        component: require("views/ThankyouView").default,
        beforeEnter: function (to, from, next) {
            if (!store.ui ||
                (store.state.mode == "backpanel" && (!store.ui.backpanelSelectionsComplete || !store.ui.backpanelMaterialSelectionsComplete)) ||
                (store.state.mode == "worktop" && (!store.ui.hobcutoutSelectionsComplete || !store.ui.sinkSelectionsComplete || !store.ui.materialSelectionsComplete || !store.ui.worktopSelectionsComplete)))
                next(false);
            else
                next();
        }
    },
    // Redirect unknown routes to start view
    { path: "*", redirect: "/" },
];
